import React, { Suspense } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Tinode } from "../tinode/tinode.js";
import PersonalInformation from "../widgets/dialog/personal-information.jsx";
import Setting from "../widgets/dialog/settings/setting.jsx";
import MessageSeenBy from '../widgets/dialog/message-seen-by.jsx';
import RenameGroup from '../widgets/dialog/rename-group.jsx';
import ReactMessage from "../widgets/dialog/react-message.jsx";
import CreatePoll from "../widgets/dialog/create-poll.jsx";
import PollMessage from "../widgets/dialog/poll-message.jsx";
import HideTopic from "../widgets/dialog/hide-topic.jsx";
import SendExcelText from "../widgets/dialog/send-excel-text.jsx";
import FindMessageResult from "../widgets/dialog/find-message-result.jsx"
import ShareGroupInviteLink from "../widgets/dialog/share-group-invite-link.jsx"
import JoinGroupInfo from "../widgets/dialog/join-group-info.jsx"
import MobilePassword from "../widgets/dialog/mobile-password.jsx"


class DialogView extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onClose = this.onClose.bind(this);
    this.getViewDialog = this.getViewDialog.bind(this);
  }

  onClose() {
    if (typeof this.props.onClose === 'function') {
      this.props.onClose()
    }
  }

  getViewDialog() {
    let element = null;
    const { dialogData } = this.props;
    if (this.props.type) {
      switch (this.props.type) {
        case Tinode.DIALOG_TYPE.SETTING:
          element = <Setting
            tinode={this.props.tinode}
            onClose={this.onClose}
            onLogout={this.props.onLogout}
            onShowAlert={this.props.onShowAlert}
            onShowDialog={this.props.onShowDialog}
            onSearchContacts={this.props.onSearchContacts}
          />;
          break;
        case Tinode.DIALOG_TYPE.PERSONAL_INFORMATION:
          element = <PersonalInformation
            onClose={this.onClose}
            tinode={this.props.tinode}
            topic={this.props.topic}
            topicName={this.props.topicName}
            onTopicSelected={this.props.onTopicSelected}
            onError={this.props.onError}
          />;
          break;
        case Tinode.DIALOG_TYPE.MESSAGE_SEEN_BY:
          element = <MessageSeenBy
            onClose={this.onClose}
            tinode={this.props.tinode}
            messageContext={this.props.messageContext}
          />;
          break;
        case Tinode.DIALOG_TYPE.RENAME_GROUP:
          element = <RenameGroup
            onClose={this.onClose}
            tinode={this.props.tinode}
            messageContext={this.props.messageContext}
          />;
          break;
        case Tinode.DIALOG_TYPE.SHOW_REACT:
          const { motions } = this.props.dialogData;
          element = <ReactMessage
            onClose={this.onClose}
            tinode={this.props.tinode}
            motions={motions}
          />;
          break;
        case Tinode.DIALOG_TYPE.CREATE_POLL:
          element = <CreatePoll
            onClose={this.onClose}
            tinode={this.props.tinode}
            topic={this.props.topic}
          />;
          break;
        case Tinode.DIALOG_TYPE.SHOW_POLL:
          element = <PollMessage
            onClose={this.onClose}
            tinode={this.props.tinode}
            topic={this.props.topic}
            pollMessageId={dialogData.pollMessageId}
          />;
          break;
        case Tinode.DIALOG_TYPE.HIDE_TOPIC: {
          const { topicName, action, subAction, callback } = this.props.dialogData;
          element = <HideTopic
            onClose={this.onClose}
            onShowAlert={this.props.onShowAlert}
            onSearchContacts={this.props.onSearchContacts}
            tinode={this.props.tinode}
            action={action}
            subAction={subAction}
            topicName={topicName}
            callback={callback}
          />;
          break
        }
        case Tinode.DIALOG_TYPE.SEND_EXCEL_TEXT: {
          const { imageExcel, imageExcelText, onSendText, onSendImage } = this.props.dialogData;
          element = <SendExcelText
            onClose={this.onClose}
            onShowAlert={this.props.onShowAlert}
            onSearchContacts={this.props.onSearchContacts}
            tinode={this.props.tinode}
            imageExcel={imageExcel}
            imageExcelText={imageExcelText}
            onSendText={onSendText}
            onSendImage={onSendImage}
          />;
          break
        }
        case Tinode.DIALOG_TYPE.FIND_MESSAGE_RESULT: {
          const { listMessage, topic, topicName, keyWord, seqId } = this.props.dialogData;
          element = <FindMessageResult
            myUserId={this.props.myUserId}
            tinode={this.props.tinode}
            onClose={this.onClose}
            topic={topic}
            topicName={topicName}
            seqId={seqId}
            keyWord={keyWord}
            listMessage={listMessage}
          />
          break
        }
        case Tinode.DIALOG_TYPE.SHARE_INVITE_GROUP_LINK: {
          const { topic, inviteUrl, groupName } = this.props.dialogData;
          element = <ShareGroupInviteLink
            contacts={this.props.contacts}
            myUserId={this.props.myUserId}
            tinode={this.props.tinode}
            onClose={this.onClose}
            topic={topic}
            inviteUrl={inviteUrl}
            groupName={groupName}
            onSearchContacts={this.props.onSearchContacts}
            searchResults={this.props.searchResults}
            sendMessageToTopic={this.props.sendMessageToTopic}
            onTopicSelected={this.props.onTopicSelected}
          />
          break
        }
        case Tinode.DIALOG_TYPE.JOIN_GROUP_LINK: {
          const { total_member, member, owner, subject, groupId, state } = this.props.dialogData
          element = <JoinGroupInfo
            myUserId={this.props.myUserId}
            tinode={this.props.tinode}
            onClose={this.onClose}
            total_member={total_member}
            member={member}
            owner={owner}
            subject={subject}
            groupId={groupId}
            state={state}
            onTopicSelected={this.props.onTopicSelected}
          />
          break
        }
        case Tinode.DIALOG_TYPE.MOBILE_PASSWORD: {
          element = <MobilePassword
            tinode={this.props.tinode}
            onClose={this.onClose}
          />
        }
        default:
          break;
      }
    }
    return element;
  }

  componentDidMount() {
    document.addEventListener('keydown', e => {
      if (e.key === "Escape" || e.keyCode === 27) {
        this.props.onClose();
      }
    })
  }

  render() {
    return (
      <React.Fragment>
        {this.props.isShow &&
          <Suspense fallback={<div className="panel-form-row"><FormattedMessage id="loading_note"
            defaultMessage="Loading..." description="Message shown when component is loading" /></div>}>
            <div className="dialog-container">
              <div className="dialog-background" onClick={this.onClose}>
              </div>
              <div className="dialog-content">
                {this.getViewDialog()}
              </div>
            </div>
          </Suspense>
        }
      </React.Fragment>
    )
  }
}

export default injectIntl(DialogView)